import ImageCropper from "./image_cropper_controller";
import Cropper from "cropperjs";

// Connects to data-controller="create-organization-modal"
export default class extends ImageCropper {
  static targets = ["firstModal", "secondModal"]

  connect() {
    $(this.firstModalTarget).modal('show')
    super.connect()
  }

  openModal() {
    const modal = document.getElementById("cropImgModal");
    const $firstModal = $('#newOrganizationModal');
    const $cropModal = $('#cropImgModal');

    // Hide the first modal
    $firstModal.modal('hide');

    // When the first modal is fully hidden, show the cropper modal
    $firstModal.one('hidden.bs.modal', function () {
      $cropModal.modal('show');
    });

    // Wait for the modal to be fully shown before initializing Cropper
    $cropModal.on('shown.bs.modal', () => {
      if (this.cropper) this.cropper.destroy();

      this.cropper = new Cropper(this.cropperImgTarget, {
        aspectRatio: 1, // 1:1 for square (circle-friendly)
        viewMode: 2,
        autoCropArea: 1,
        responsive: true,
        background: false,
        ready: () => {
          document.getElementById("cropImgModal").classList.add('circular-cropper-wrapper');
        }
      });
    });

    this.clearCropper(modal)
  }

  closeModal() {
    $('#cropImgModal').modal('hide');
    $('#cropImgModal').on('hidden.bs.modal', function () {
      $('#newOrganizationModal').modal('show');
      $(this).off('hidden.bs.modal');
    });
  }
}
